<template>
  <v-container>
    <v-row>
    <project-summary v-bind:isBalance="true"></project-summary>
    </v-row>
    <template>
      <table id="balance-table">
        <tr class="balance-row">
        <thead>
          <th class="toggle-cell"><!-- empty because of toggle-icon--></th>
          <th class="text-cell"><!-- empty becaus of name --></th>
          <th class="number-cell">%</th>
          <th class="number-cell">N(t)</th>
          <th class="number-cell">N(kg/ha)</th>
          <th class="number-cell">P(t)</th>
          <th class="number-cell">P(kg/ha)</th>
          <th class="number-cell">K(t)</th>
          <th class="number-cell">K(kg/ha)</th>
        </thead>
        </tr>
        <div class="balance-table-scrollable">
          <!-- Plant Table -->
          <tr>
          <thead>
            <td class="toggle-cell">
              <v-btn v-if="balance.groups[0].length > 0"
                icon 
                @click="expand('animal')" 
                class="data-table__toggle-btn"
              >
                <v-icon v-if="this.animalToggle">
                  mdi-chevron-down
                </v-icon>
                <v-icon v-else>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </td>
            <th class="text-cell balance-head-font">
              {{$t('nutrientBalance.animalTitle')}}
            </th>
            <th class="number-cell">
              <!-- empty because of pct -->
            </th>
            <!-- Column#2: mass N in t-->
            <th class="number-cell">
              <formatted-value :value="getMass(0, 'N')" :scale="0.001" />
            </th>
            <!-- Column#3: mass N kg/ha-->
            <th class="number-cell"> 
              <formatted-value :value="getMassPerHa(0, 'N')" />
            </th>
            <!-- Column#4: mass N in t-->
            <th class="number-cell">
              <formatted-value :value="getMass(0, 'P')" :scale="0.001" />
            </th>
            <!-- Column#5: mass P kg/ha-->
            <th class="number-cell">
              <formatted-value :value="getMassPerHa(0, 'P')" />
            </th>
            <!-- Column#6: mass N in t-->
            <th class="number-cell">
              <formatted-value :value="getMass(0, 'K')" :scale="0.001" />
            </th>
            <!-- Column#7: mass P kg/ha-->
            <th class="number-cell">
              <formatted-value :value="getMassPerHa(0, 'K')" />
            </th>

          </thead>
          </tr>
        
          <!-- Plant - Table body -->
          <div v-if="this.animalToggle">
            <tr v-for="(item, idx) in balance.groups[0]" :key="idx">
              <td class="toggle-cell"><!-- empty because of toggle-icon--></td>
              <td class="text-cell">
                {{getCategoryName(item.name)}}
              </td>
              <td class="number-cell"><!-- empty because of pct --></td>
              <td class="number-cell">
                <formatted-value 
                  :value="(item.Nkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>
              
              <td class="number-cell">
                <formatted-value 
                  :value="(item.N)"
                  :precision="0" 
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value
                  :value="(item.Pkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value 
                  :value="(item.P)"
                  :precision="0" 
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value
                  :value="(item.Kkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value 
                  :value="(item.K)"
                  :precision="0" 
                  showZero
                />
              </td>

            </tr>
          </div>

          <!-- Animal Table -->
          <tr>
          <thead>
            <td class="toggle-cell">
              <v-btn v-if="balance.groups[1].length > 0"
                icon 
                @click="expand('plant')" 
                class="data-table__toggle-btn"
              >
                <v-icon v-if="this.plantToggle">
                  mdi-chevron-down
                </v-icon>
                <v-icon v-else>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </td>
            <th class="text-cell balance-head-font">
              {{$t('nutrientBalance.plantTitle')}}
            </th>
            <!-- Column#1: empty -->
            <th class="number-cell"></th>
            <!-- Column#2: mass N in t-->
            <th class="number-cell"> 
              <formatted-value :value="getMass(1, 'N')" :scale="0.001" />
            </th>
            <!-- Column#3: mass N kg/ha-->
            <th class="number-cell"> 
              <formatted-value :value="getMassPerHa(1, 'N')" />
            </th>
            <!-- Column#4: mass N in t-->
            <th class="number-cell">
              <formatted-value :value="getMass(1, 'P')" :scale="0.001" />
            </th>
            <!-- Column#5: mass P kg/ha-->
            <th class="number-cell">
              <formatted-value :value="getMassPerHa(1, 'P')" />
            </th>
            <!-- Column#6: mass N in t-->
            <th class="number-cell">
              <formatted-value :value="getMass(1, 'K')" :scale="0.001" />
            </th>
            <!-- Column#7: mass P kg/ha-->
            <th class="number-cell">
              <formatted-value :value="getMassPerHa(1, 'K')" />
            </th>

          </thead>
          </tr>
        
          <!-- Plant - Table body -->
          <div v-if="this.plantToggle">
            <tr v-for="(item, idx) in balance.groups[1]" :key="idx">
              <td class="toggle-cell"><!-- empty because of toggle-icon--></td>
              <td class="text-cell">
                {{getCategoryName(item.name)}}
              </td>
              <td class="number-cell">
                <!-- empty because of pct -->
              </td>
              <td class="number-cell">
                <formatted-value 
                  :value="(item.Nkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>
              
              <td class="number-cell">
                <formatted-value 
                  :value="(item.N)"
                  :precision="0" 
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value
                  :value="(item.Pkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value 
                  :value="(item.P)"
                  :precision="0" 
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value
                  :value="(item.Kkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>

              <td class="number-cell">
                <formatted-value 
                  :value="(item.K)"
                  :precision="0" 
                  showZero
                />
              </td>

            </tr>
          </div>

          <!-- BNF Table -->
          <tr>
          <thead>
            <td class="toggle-cell">
              <v-btn v-if="balance.groups[2].length > 0"
                icon 
                @click="expand('bnf')" 
                class="data-table__toggle-btn"
              >
                <v-icon v-if="this.bnfToggle">
                  mdi-chevron-down
                </v-icon>
                <v-icon v-else>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </td>
            <th class="text-cell balance-head-font">
              {{$t('nutrientBalance.bnfTitle')}}
            </th>
            <th class="number-cell"><!-- empty because of pct --></th>
            <!-- Column#2: mass N in t-->
            <th class="number-cell"> 
              <formatted-value :value="getMass(2, 'N')" :scale="0.001" />
            </th>
            <!-- Column#3: mass N kg/ha-->
            <th class="number-cell"> 
              <formatted-value :value="getMassPerHa(2, 'N')" />
            </th>
            <!-- Column#4: mass N in t-->
            <th class="number-cell">
              <!-- empty for BNF -->
            </th>
            <!-- Column#5: mass P kg/ha-->
            <th class="number-cell">
              <!-- empty for BNF -->
            </th>
            <!-- Column#6: mass N in t-->
            <th class="number-cell">
              <!-- empty for BNF -->
            </th>
            <!-- Column#7: mass P kg/ha-->
            <th class="number-cell">
              <!-- empty for BNF -->
            </th>

          </thead>
          </tr>
        
          <!-- BNF - Table body -->
          <div v-if="this.bnfToggle">
            <tr v-for="(item, idx) in balance.groups[2]" :key="idx">
              <td class="toggle-cell"><!-- empty because of toggle-icon--></td>
              <td class="text-cell">
                {{getCategoryName(item.name)}}
              </td>
              <td class="number-cell">
                <!-- empty because of pct -->
              </td>
              <td class="number-cell">
                <formatted-value 
                  :value="(item.Nkg)"
                  :scale="0.001"
                  :precision="0"
                  showZero
                />
              </td>
              
              <td class="number-cell">
                <formatted-value 
                  :value="(item.N)"
                  :precision="0" 
                  showZero
                />
              </td>

              <td class="number-cell">
                <!-- empty for BNF -->
              </td>

              <td class="number-cell">
                <!-- empty for BNF -->
              </td>

              <td class="number-cell">
                <!-- empty for BNF -->
              </td>

              <td class="number-cell">
                <!-- empty for BNF -->
              </td>

            </tr>
          </div>

          <!-- Depositions and Unavoidable losses -->
          <tr>
            <thead>
              <th class="toggle-cell">
                <!-- empty because of toggle icon -->
              </th>
              <th class="text-cell balance-head-font">
                {{ $t('nutrientBalance.deposition') }}
              </th>
              <th class="number-cell"></th>
              <th class="number-cell">
                <formatted-value :value="balance['N'].deposition" />
              </th>
              <th class="number-cell">
                <v-text-field
                  v-model.number="project.deposition"
                  size="6"
                  hide-details
                  type="number"
                /> 

              </th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
            </thead>
          </tr>
          <tr>
            <thead>
              <td class="toggle-cell">
                <v-btn icon @click="expand('loss')" class="data-table__toggle-btn">
                  <v-icon v-if="this.lossToggle">
                    mdi-chevron-down
                  </v-icon>
                  <v-icon v-else>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </td>
              <th class="text-cell balance-head-font">
                {{ $t('nutrientBalance.fertilizerLoss') }}
              </th>
              <th class="number-cell">
                <formatted-value v-if="balance.acreage_sum" :value="balance['N'].losses_pct" />
              </th>
              <th class="number-cell">
                <formatted-value :value="balance['N'].losses" :scale="0.001" />
              </th>
              <th class="number-cell">
                <formatted-value v-if="balance.acreage_sum" :value="balance['N'].losses_per_ha" />
              </th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
              <th class="number-cell"></th>
            </thead>
          </tr>
          
          <!-- Unavoidable losses summary row -->
          <div v-if="this.lossToggle">
            <tr>
              <td class="toggle-cell"><!-- empty because of toggle icon --></td>
              <td class="text-cell">
                {{ $t('nutrientBalance.stallLoss') }}
              </td>
              <td class="number-cell">
                <v-text-field
                  v-model="project.lossesStorage"
                  size="6"
                  hide-details
                  type="number"
                />
              </td>
              <td class="number-cell">
                <formatted-value :value="balance['N'].losses_storage" :scale="0.001"/>
                              
              </td>
              <td class="number-cell">
                <formatted-value
                  v-if="balance.acreage_sum" 
                  :value="balance['N'].losses_storage_per_ha"
                />
              </td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
            </tr>
            <tr>
              <td class="toggle-cell"><!-- empty because of toggle icon --></td>
              <td class="text-cell">
                {{ $t('nutrientBalance.outputLoss') }}
              </td>
              <td class="number-cell">
                <v-text-field
                  v-model="project.lossesOutput"
                  size="6"
                  hide-details
                  type="number"
                />
              </td>
              <td class="number-cell">
                <formatted-value 
                  :value="balance['N'].losses_output" 
                  :scale="0.001" />
              </td>
              <td class="number-cell">
                <formatted-value 
                  v-if="balance.acreage_sum" 
                  :value="balance['N'].losses_output_per_ha" />
              </td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
              <td class="number-cell"></td>
            </tr>
          </div>
        </div>
        </table>
    </template>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import FormattedValue from "../components/FormattedValue.vue";
import ProjectSummary from '../components/ProjectSummary.vue';
// import prj from '@/project.js'

export default {
  components: {
    FormattedValue,
    ProjectSummary,
  },

  data() {
    return {
      animalToggle: false,
      lossToggle: true,
      plantToggle: false,
      bnfToggle: false,
      isDesc: false, 
    };
  },

  computed: {
    ...mapGetters(["balance"]),

    ...mapState(["project", "categories", "locale"]),
    nameProperty: function () {
      return 'name_'+this.locale
    }  
  },

  methods: {

    getCategoryName(category) {
      let cat = this.categories.find((c) => c.id == category);
      let name = cat ? cat[this.nameProperty] : "";
      return name;
    },

    expand(group) {
      if (group === "loss")
        this.lossToggle = !this.lossToggle;

      if(group === "animal")
        this.animalToggle = !this.animalToggle;

      if(group === "plant")
        this.plantToggle = !this.plantToggle;

      if(group === "bnf")
        this.bnfToggle = !this.bnfToggle;
    },

    /**
     * Get summary value: Total mass of nutrient.
     *
     * @param balanceGroup 0: Nutrient demand, 1: Fertilizer production, 2: BNF
     * @param nutrientKey One of 'N', 'P', 'K'
     */
    getMass(balanceGroup, nutrientKey) {
      switch (balanceGroup) {
        case 0:
          return this.balance[nutrientKey].nutrient_demand;
        case 1:
          return this.balance[nutrientKey].fertilizer_prod;
        case 2:
          return this.balance[nutrientKey].bnf;
      }
    },

    /**
     * Get summary value: Mass of nutrient in kg/ha.
     *
     * @param balanceGroup 0: Nutrient demand, 1: Fertilizer production, 2: BNF
     * @param nutrientKey One of 'N', 'P', 'K'
     */
    getMassPerHa(balanceGroup, nutrientKey) {
      switch (balanceGroup) {
        case 0:
          return this.balance[nutrientKey].nutrient_demand_per_ha;
        case 1:
          return this.balance[nutrientKey].fertilizer_prod_per_ha;
        case 2:
          return this.balance[nutrientKey].bnf_per_ha;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.group-header {
  thead {
    background-color: white;
    padding-left: 0 !important;
    font-weight: bold;
  }
}
.v-btn::before {
  background-color: transparent;
}
</style>
